// Core React imports
import { FacebookContentTag } from "store/platforms/types";
import { useTranslation } from "react-i18next";
import { BaseAssignment } from "components/inputs/assignment/base-assignment";

export const ContentTagsSelector = ({
    availableContentTags,
    selectedContentTags,
    setSelectedContentTags,
    tagsLoading,
    onSearch
}) => {
    const { t } = useTranslation();
    return (
        <div>
            <BaseAssignment<FacebookContentTag>
                items={availableContentTags}
                itemIdKey={"id"}
                itemLabelKey={"name"}
                labels={{
                    appliedItemsLabel: t("platforms:content-tags"),
                    noItemsAppliedLabel: t("video-upload:no-tags-applied"),
                    selectLabel: " ",
                    selectPlaceholder: t(
                        "facebook-destination:select-content-tags"
                    ),
                    inputLabel: t("facebook-destination:search-tags"),
                    inputPlaceholder: null
                }}
                assignedItems={selectedContentTags || []}
                variant="search"
                handleAssignItem={(item) => {
                    setSelectedContentTags(
                        !!selectedContentTags?.length
                            ? [...selectedContentTags, item]
                            : [item]
                    );
                }}
                handleAddItem={(query: string) => {
                    onSearch(query);
                }}
                itemsLoading={tagsLoading}
                handleRemoveItem={(itemId) => {
                    setSelectedContentTags(
                        selectedContentTags.filter((i) => i.id !== itemId)
                    );
                }}
            />
        </div>
    );
};
